import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import UserStore from 'stores/UserStore';
import Button from 'components/Button/Button';
import { generateID } from 'utils/helpers';

import iconDone from '../../../images/icon-done.png';
import sendingImage from '../../../images/user/email-sent.png';

import styles from './VerifyEmailSent.css';


const IDS = {
  prefix: 'jtymt23l',
  element: 'VerifyEmailSent',
  closeBtn: 'closeBtn',
  resendBtn: 'resendBtn',
};
const makeId = generateID(IDS.prefix, IDS.element);

const VerifyEmailSent = (props) => {
  const { setIsAnyModalShown, onClickClose } = props;
  const { resendEmail, resendEmailResponse, resendEmailValue } = UserStore;

  const onClose = useCallback(() => {
    setIsAnyModalShown(false);
    onClickClose();
  }, [onClickClose, setIsAnyModalShown]);

  const onClickResend = useCallback(() => {
    resendEmail(resendEmailValue);
  }, [resendEmail, resendEmailValue]);

  return (
    <div className={styles.emailSentWrapper}>
      <script
        data-goal="5c21fc94fecd6dd522e9435550790452"
        src="https://a.exoclick.com/tag_gen.js"
        type="application/javascript"
      />
      <img
        alt=""
        className={styles.sendingImg}
        src={sendingImage}
      />
      <div className={styles.body}>
        <h4 className={styles.title}>
          {translate('verification.verify.your.email.address')}
        </h4>
        {resendEmailResponse ? (
          <div className={styles.success}>
            <img
              alt="Success icon"
              className={styles.checkImage}
              src={iconDone}
            />
            <p className={styles.emailResent}>
              {translate('verification.email.resent')}
            </p>
            <div>
              {translate('verification.click.link.email')}
            </div>
          </div>
        ) : (
          <Fragment>
            <p className={styles.firstInfo}>
              {translate('verification.must.click.to.verify.email')}
            </p>
            <p className={styles.firstInfo}>
              {translate('verification.not.receive.email')}
            </p>
            <Button
              className={styles.resendBtn}
              id={makeId(IDS.resendBtn)}
              label={translate('verification.verification.email.resend')}
              onClick={onClickResend}
            />
          </Fragment>
        )}
        <p className={styles.ensureInfo}>
          {translate('verification.verification.email.ensure.delivery')}
        </p>
      </div>
      <div className={styles.footer}>
        <Button
          colour="transparent"
          id={makeId(IDS.closeBtn)}
          label={translate('v2profile.button.close')}
          onClick={onClose}
        />
      </div>
    </div>
  );
};

VerifyEmailSent.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  setIsAnyModalShown: PropTypes.func,
};

VerifyEmailSent.defaultProps = { setIsAnyModalShown: () => undefined };

export default observer(VerifyEmailSent);
